(function () {
  'use strict';

  function init() {
    document.querySelectorAll('.bsb-pt').forEach(initSection);
  }

  function initSection(section) {
    if (section.dataset.bsbPtInitialized) return;
    section.dataset.bsbPtInitialized = 'true';

    const tabs          = Array.from(section.querySelectorAll('[role="tab"]'));
    const panels        = Array.from(section.querySelectorAll('[role="tabpanel"]'));
    const swipers       = {};
    const slidesDesktop = parseFloat(section.dataset.slidesDesktop) || 5;
    const slidesMobile  = parseFloat(section.dataset.slidesMobile)  || 1.5;

    function activate(tab) {
      const idx = tabs.indexOf(tab);

      tabs.forEach((t, i) => {
        const active = i === idx;
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
        t.classList.toggle('bsb-pt__tab--active', active);
      });

      panels.forEach((panel, i) => {
        if (i === idx) {
          panel.removeAttribute('hidden');
          const swiperId = panel.querySelector('.swiper')?.id;
          if (swiperId && swipers[swiperId]) swipers[swiperId].update();
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    const tablist = section.querySelector('.bsb-pt__tablist');
    if (tablist) {
      const updateTablistFade = () => {
        const atEnd = tablist.scrollLeft + tablist.clientWidth >= tablist.scrollWidth - 2;
        tablist.classList.toggle('bsb-pt__tablist--end', atEnd);
      };
      tablist.addEventListener('scroll', updateTablistFade, { passive: true });
      updateTablistFade();
    }

    tabs.forEach(tab => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', e => {
        const idx = tabs.indexOf(tab);
        if (e.key === 'ArrowRight') {
          const next = tabs[(idx + 1) % tabs.length];
          activate(next);
          next.focus();
        }
        if (e.key === 'ArrowLeft') {
          const prev = tabs[(idx - 1 + tabs.length) % tabs.length];
          activate(prev);
          prev.focus();
        }
      });
    });

    if (typeof Swiper === 'undefined') return;

    section.querySelectorAll('.swiper').forEach((el) => {
      const wrap    = el.closest('.bsb-pt__carousel-wrap');
      const prevBtn = wrap?.querySelector('[data-swiper-prev]');
      const nextBtn = wrap?.querySelector('[data-swiper-next]');

      swipers[el.id] = new Swiper(el, {
        slidesPerView: slidesMobile,
        spaceBetween: 14,
        threshold: 5,
        slideToClickedSlide: false,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true
        },
        breakpoints: {
          769: {
            slidesPerView: slidesDesktop,
            spaceBetween: 14,
            pagination: { enabled: false }
          }
        },
        grabCursor: true,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'bsb-pt__arrow--disabled'
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide'
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
